import React from "react";
import { Breadcrumb, Card, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Support = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="main pt-4 pb-5">
        <Container className="py-5">
          <div className="product_breadcrumb">
            <Breadcrumb>
              <Breadcrumb.Item onClick={() => navigate("/")}>
                Home
              </Breadcrumb.Item>
              <Breadcrumb.Item
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </Breadcrumb.Item>
              <Breadcrumb.Item active>Support</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Row>
            <Col md={3} xl={3} className="px-sm-0 px-xs-0">
              <div className="d-grid gap-2 pb-3 Account_card_div">
                <div className="Account_btns Faq_Cards p-4 align_center">
                  <h6 className="pt-2 ">
                    <b>Have Questions?</b>
                  </h6>
                  <p className="text_muted">
                    Call (833) 465 0300 or contact us via chat.
                  </p>
                </div>
              </div>
            </Col>
            <Col md={9} xl={9} className="px-5 px-sm-0 Shipping_Card_wrapper">
              <Card className=" Shipping_Card box_shadow">
                <Card.Header className="blue_bg Account_Card_Header ">
                  <Container>
                    <Row>
                      <Col className="Header_Text ps-4 ">
                        <b>Customer Support </b>
                      </Col>
                    </Row>
                  </Container>
                </Card.Header>
                <Card.Body className="px-4">
                  <div className="Shipping_Card_text">
                    <p className="text_muted">
                      We're proud to offer an assortment of hands on support
                      processes to ensure your software is up and running with
                      minimal downtime. From carefully written instructions to
                      download your software found in your account area, to
                      remote assistance offered by our team. Our dedicated staff
                      works around the clock to make the installation of your
                      new softwae seamingless.
                    </p>
                    <br />
                    <p className="text_muted">
                      Please contact our support team by clicking the chat icon
                      at the bottom right corner of this screen.
                    </p>
                  </div>
                </Card.Body>
              </Card>

              <Card className="Shipping_Card box_shadow mt-5">
                <Card.Header className="blue_bg Account_Card_Header ">
                  <Container>
                    <Row>
                      <Col className="Header_Text ps-4 ">
                        <b>Customer Satisfaction - Guaranteed </b>
                      </Col>
                    </Row>
                  </Container>
                </Card.Header>
                <Card.Body className="px-4 pt-4">
                  <div className="Shipping_Card_text">
                    <p className="text_muted">
                      Shop with confidence knowing that we offer a 90-day
                      hassle-free refund policy for all purchases made at
                      Liberty Programs. If you're not completelty satisfied with
                      your purchase, please reach out to our sales team for a
                      full refund. Terms and conditions may apply.
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Support;
